export const INITIAL_MAX_ROWS = 5;
